import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { EventTypes } from "../interfaces";
var RotationGestureDetector = /*#__PURE__*/ function() {
    "use strict";
    function RotationGestureDetector(callbacks) {
        _class_call_check(this, RotationGestureDetector);
        _define_property(this, "onRotationBegin", void 0);
        _define_property(this, "onRotation", void 0);
        _define_property(this, "onRotationEnd", void 0);
        _define_property(this, "currentTime", 0);
        _define_property(this, "previousTime", 0);
        _define_property(this, "previousAngle", 0);
        _define_property(this, "rotation", 0);
        _define_property(this, "anchorX", 0);
        _define_property(this, "anchorY", 0);
        _define_property(this, "isInProgress", false);
        _define_property(this, "keyPointers", [
            NaN,
            NaN
        ]);
        this.onRotationBegin = callbacks.onRotationBegin;
        this.onRotation = callbacks.onRotation;
        this.onRotationEnd = callbacks.onRotationEnd;
    }
    _create_class(RotationGestureDetector, [
        {
            key: "updateCurrent",
            value: function updateCurrent(event, tracker) {
                this.previousTime = this.currentTime;
                this.currentTime = event.time;
                var _this_keyPointers = _sliced_to_array(this.keyPointers, 2), firstPointerID = _this_keyPointers[0], secondPointerID = _this_keyPointers[1];
                var firstPointerX = tracker.getLastX(firstPointerID);
                var firstPointerY = tracker.getLastY(firstPointerID);
                var secondPointerX = tracker.getLastX(secondPointerID);
                var secondPointerY = tracker.getLastY(secondPointerID);
                var vectorX = secondPointerX - firstPointerX;
                var vectorY = secondPointerY - firstPointerY;
                this.anchorX = (firstPointerX + secondPointerX) / 2;
                this.anchorY = (firstPointerY + secondPointerY) / 2;
                //Angle diff should be positive when rotating in clockwise direction
                var angle = -Math.atan2(vectorY, vectorX);
                this.rotation = Number.isNaN(this.previousAngle) ? 0 : this.previousAngle - angle;
                this.previousAngle = angle;
                if (this.rotation > Math.PI) {
                    this.rotation -= Math.PI;
                } else if (this.rotation < -Math.PI) {
                    this.rotation += Math.PI;
                }
                if (this.rotation > Math.PI / 2) {
                    this.rotation -= Math.PI;
                } else if (this.rotation < -Math.PI / 2) {
                    this.rotation += Math.PI;
                }
            }
        },
        {
            key: "finish",
            value: function finish() {
                if (!this.isInProgress) {
                    return;
                }
                this.isInProgress = false;
                this.keyPointers = [
                    NaN,
                    NaN
                ];
                this.onRotationEnd(this);
            }
        },
        {
            key: "setKeyPointers",
            value: function setKeyPointers(tracker) {
                if (this.keyPointers[0] && this.keyPointers[1]) {
                    return;
                }
                var pointerIDs = tracker.getData().keys();
                this.keyPointers[0] = pointerIDs.next().value;
                this.keyPointers[1] = pointerIDs.next().value;
            }
        },
        {
            key: "onTouchEvent",
            value: function onTouchEvent(event, tracker) {
                switch(event.eventType){
                    case EventTypes.DOWN:
                        this.isInProgress = false;
                        break;
                    case EventTypes.ADDITIONAL_POINTER_DOWN:
                        if (this.isInProgress) {
                            break;
                        }
                        this.isInProgress = true;
                        this.previousTime = event.time;
                        this.previousAngle = NaN;
                        this.setKeyPointers(tracker);
                        this.updateCurrent(event, tracker);
                        this.onRotationBegin(this);
                        break;
                    case EventTypes.MOVE:
                        if (!this.isInProgress) {
                            break;
                        }
                        this.updateCurrent(event, tracker);
                        this.onRotation(this);
                        break;
                    case EventTypes.ADDITIONAL_POINTER_UP:
                        if (!this.isInProgress) {
                            break;
                        }
                        if (this.keyPointers.indexOf(event.pointerId) >= 0) {
                            this.finish();
                        }
                        break;
                    case EventTypes.UP:
                        if (this.isInProgress) {
                            this.finish();
                        }
                        break;
                }
                return true;
            }
        },
        {
            key: "getTimeDelta",
            value: function getTimeDelta() {
                return this.currentTime + this.previousTime;
            }
        },
        {
            key: "getAnchorX",
            value: function getAnchorX() {
                return this.anchorX;
            }
        },
        {
            key: "getAnchorY",
            value: function getAnchorY() {
                return this.anchorY;
            }
        },
        {
            key: "getRotation",
            value: function getRotation() {
                return this.rotation;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.keyPointers = [
                    NaN,
                    NaN
                ];
                this.isInProgress = false;
            }
        }
    ]);
    return RotationGestureDetector;
}();
export { RotationGestureDetector as default };
